package com.shadowings.gero.data.lessons.chapter16

import com.shadowings.gero.data.lessons.NounAdjectivePhrase
import com.shadowings.gero.data.lessons.buildNounAdjectiveFormChoice
import com.shadowings.gero.data.lessons.buildNounAdjectiveWordSelection
import com.shadowings.gero.domain.model.IQuizContent
import kotlin.random.Random

// Splits a random pick of phrases into batches of sizes[i] per Egyptian gender, each phrase on a
// different noun. The noun is drawn first and then one of its adjectives, so a noun with six
// valid adjectives doesn't come out six times as often as one with two.
internal fun pickPerGender(
    phrases: List<NounAdjectivePhrase>,
    sizes: List<Int>,
    random: Random
): List<List<NounAdjectivePhrase>> {
    val byGender = phrases.partition { it.noun.isFeminine }.toList().map { sameGender ->
        sameGender.groupBy { it.noun.id }.values.shuffled(random).map { it.random(random) }
    }
    var start = 0
    return sizes.map { size ->
        val batch = byGender.flatMap { it.drop(start).take(size) }
        start += size
        batch
    }
}

// Shared by AGGETTIVI_GENERE and AGGETTIVI_PLURALE: translations to build + hieroglyphs to pick.
internal fun buildAdjectiveAgreementQuizzes(
    translate: List<NounAdjectivePhrase>,
    choose: List<NounAdjectivePhrase>,
    pool: List<NounAdjectivePhrase>,
    includeNumber: Boolean,
    languageCode: String,
    random: Random
): List<IQuizContent> {
    val nouns = pool.map { it.noun }.distinctBy { it.id }
    val adjectives = pool.map { it.adjective }.distinctBy { it.id }
    return translate.map { buildNounAdjectiveWordSelection(it, nouns, adjectives, languageCode, random) } +
        choose.map { buildNounAdjectiveFormChoice(it, includeNumber, adjectives, random) }
}
